<template>
    <flex-container
        align-content="center"
        justify-content="center"
        height="full"
    >
        <flex-container
            size="full"
            justify-content="center"
            :screen-sizes="{
                tablet: 5,
            }"
            gap="xl"
        >
            <flex-container
                :size="7"
                justify-content="center"
                :screen-sizes="{
                    tablet: 5,
                }"
            >
                <pull-request-icon
                    :style="{ color: getCssColor('default', 'primary') }"
                />
            </flex-container>
            <flex-container
                size="full"
                :screen-sizes="{
                    tablet: 10,
                }"
                direction="column"
                gap="md"
            >
                <h1>
                    Wat is jouw eerste stap, {{ currentUser.name.firstName }}?
                </h1>
                <text-description>
                    Ontdek ons aanbod van kant-en-klare opvolgingsflows, speciaal ontworpen om jouw leads en klanten effectief op te volgen met slechts een paar klikken. Of je nu focust op de lange termijn, serviceverlening wilt verbeteren, of jouw omzet wilt verhogen, wij bieden de perfecte oplossing. Alles is direct toegankelijk met één simpele klik. Begin vandaag nog: klik op 'Nieuwe flow' en kies jouw eerste flow. Jouw pad naar succesvol klantbeheer start hier.
                </text-description>
                <div>
                    <create-flow-from-template-button />
                </div>
            </flex-container>
        </flex-container>
    </flex-container>
</template>

<script setup lang="ts">
    import PullRequestIcon from '@/assets/icons/undraw/pull_request.svg?component';
    import CreateFlowFromTemplateButton from '@/flow/template/components/CreateFlowFromTemplateButton.vue';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import { getCssColor } from '@keyvue/one-ui';

    const { currentUser } = useClient();
</script>
